import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// @mui material components
import MDTypography from "ui/MDTypography";
import karkunService from "services/karkun-service"; // Import your client service
import { Status } from "layouts/common/columns";
import { DetailRow } from "layouts/common/detail-page";
import { EditButton } from "layouts/common/buttons";
import { DeleteButton } from "layouts/common/buttons";
import { DetailPageLayout } from "examples/LayoutContainers/DetailPageLayout";
import { Grid } from "@mui/material";
import centerService from "services/center-service";
import { PermissionButton } from "layouts/common/buttons";
import { QRCodeCanvas } from "qrcode.react";

const KarkunDetail = () => {
  const { id } = useParams();
  const [karkun, setKarkun] = useState([]);
  const [loading, setLoading] = useState(true);
  const [centerName, setCenterName] = useState("");

  useEffect(() => {
    const fetchKarkun = async () => {
      try {
        const karkunData = await karkunService.getById(id);
        if (karkunData.success && karkunData.karkun) {
          setKarkun(karkunData.karkun);

          // 🔁 Fetch all centers
          const centerListData = await centerService.getAll();
          if (centerListData.success && centerListData.centers) {
            const matchedCenter = centerListData.centers.find(
              (c) => c.id === karkunData.karkun.center
            );

            if (matchedCenter) {
              setCenterName(matchedCenter.name);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching karkun or center data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchKarkun();
  }, [id]);


  const renderKarkunDetails = () => {
    if (!karkun) {
      return <MDTypography variant="body2" color="error">Karkun Not Found</MDTypography>;
    }

    const { name, fathername, phone, email, address, city, country, ehad, marfat, center, karkunid } = karkun;
    return (
      <Grid container spacing={2} padding={2}>
        {/* Row 1 */}
        <Grid item xs={12}>
          <Grid container spacing={2} justifyContent="flex-start" alignItems="stretch">
            <Grid item xs={6} sm={6} md={3}>
              <DetailRow label="Name" value={name} />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <DetailRow label="Father Name" value={fathername} />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <DetailRow label="Contact" value={phone} />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <DetailRow label="Email" value={email} />
            </Grid>
          </Grid>
        </Grid>

        {/* Row 2 */}
        <Grid item xs={12}>
          <Grid container spacing={2} justifyContent="flex-start" alignItems="stretch">
            <Grid item xs={6} sm={6} md={3}>
              <DetailRow label="Address" value={address} />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <DetailRow label="City" value={city} />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <DetailRow label="Country" value={country} />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <DetailRow label="Arsa Ehad" value={ehad} />
            </Grid>
          </Grid>
        </Grid>

        {/* Row 3 */}
        <Grid item xs={12}>
          <Grid container spacing={2} justifyContent="flex-start" alignItems="stretch">
            <Grid item xs={6} sm={6} md={3}>
              <DetailRow label="Marfat" value={marfat} />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <DetailRow label="Center Title" value={centerName} />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <DetailRow label="Karkun ID" value={karkunid} />
            </Grid>
          </Grid>
        </Grid>
        {karkun.qrUrl && (
          <Grid item xs={12} textAlign="center" marginTop={3}>
            <MDTypography variant="h6" color="dark">
              Karkun QR Code
            </MDTypography>
            <QRCodeCanvas
              value={karkun.qrUrl}
              size={180}
              bgColor="#ffffff"
              fgColor="#000000"
              level="H"
              includeMargin={true}
              style={{ marginTop: "10px" }}
            />
          </Grid>
        )}

      </Grid>
    );

  };

  const actionButtons = () => {
    return (
      <>
        <PermissionButton permissions={["karkun:edit"]}>
          <EditButton
            link={`/karkuns/${karkun?.id}/edit`} // Safely access client.id
          />
        </PermissionButton>
        {/* <PermissionButton permissions={["karkun:delete"]}>


          <DeleteButton
            clickHandler={() => handleDelete(karkun?.id)}
          />

        </PermissionButton> */}
      </>
    );
  }

  return (
    <DetailPageLayout
      title={"Details"}
      renderContent={renderKarkunDetails}
      actionButtons={actionButtons}
      backButtonRoute={'/karkuns'}
      loading={loading}
    />
  );
};

export default KarkunDetail;